import angular from 'angular';
import './unknown-batchref-modal.component.js';
import _ from 'lodash';
import gridHeight from '../../../app/core/shared-service/grid-utils';

class UnknownBatchRefCtrl {
    /*@ngInject*/
    constructor(
        $state,
        $uibModal,
        toastr,
        logger,
        $translate,
        CONF,
        API_CONFIG,
        INDEX_FILE_STATUS,
        IndexFilesFilter,
        IndexFileService,
        SessionSvc,
        LadProviderService,
        DateService,
        dateFilter,
        IndexFile,
        UtilSvc
    ) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.toastr = toastr;
        this.logger = logger;
        this.$translate = $translate;
        this.CONF = CONF;
        this.API_CONFIG = API_CONFIG;
        this.INDEX_FILE_STATUS = INDEX_FILE_STATUS;
        this.IndexFilesFilter = IndexFilesFilter;
        this.IndexFileService = IndexFileService;
        this.SessionSvc = SessionSvc;
        this.LadProviderService = LadProviderService;
        this.DateService = DateService;
        this.dateFilter = dateFilter;
        this.IndexFile = IndexFile;
        this.UtilSvc = UtilSvc;
    }

    $onInit() {
        let vm = this;

        // ----------------------------
        // Data API
        // ----------------------------
        // Init des données
        vm.ladProviders = vm.LadProviderService.findAll();
        // Recherche
        vm.statusList = vm.INDEX_FILE_STATUS;
        vm.searchData = new vm.IndexFilesFilter();
        // ----------------------------
        // Function API
        // ----------------------------
        vm.downloadUrl = vm.IndexFileService.getDownloadUrl();
        // Export CSV
        vm.search = search;
        vm.clearForm = clearForm;

        var defaultCellTemplate =
            '<div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div>';

        // Liste
        vm.gridOptions = {
            columnDefs: [
                {
                    name: 'ladProviderName',
                    displayName: 'dashboard.column.indexfile.ladProvider',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'receptionDate',
                    displayName: 'dashboard.column.indexfile.reception_date',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellFilter: "date:'short'",
                    cellClass: 'pointer',
                },
                {
                    name: 'getStatusLabel()',
                    displayName: 'dashboard.column.indexfile.status_header',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'reference',
                    displayName: 'dashboard.column.indexfile.reference',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
            ],
            useExternalPagination: false,
            useExternalSorting: false,
            enableSorting: true,
            enableGridMenu: false,
            enableRowSelection: true,
            enableSelectAll: true,
            selectionRowHeaderWidth: 30,
            exporterMenuCsv: false,
            enableColumnMenus: false,
            exporterCsvColumnSeparator: ';',
            exporterOlderExcelCompatibility: true,
            exporterHeaderFilter: vm.$translate.instant,
            exporterFieldCallback: function (grid, row, col, value) {
                if (col.name === 'receptionDate') {
                    value = vm.dateFilter(value, 'shortDate');
                }
                return value;
            },
            gridMenuTitleFilter: vm.$translate,
            onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;
            },
        };

        vm.preparedSearchFilter = {};
        vm.headers = [];

        if (vm.specificFormUnknownBatchRef === 'errors') {
            vm.searchData.indexStatus = vm.INDEX_FILE_STATUS[2];
        }

        //recuperer la liste des headers pour l'export
        vm.headers = _.map(vm.gridOptions.columnDefs, function (column) {
            return vm.$translate.instant(column.displayName);
        });

        function search() {
            vm.preparedSearchFilter = vm.searchData.preparBeforeSearch();
            var createdDateFrom = vm.UtilSvc.mixteDateTime(
                vm.searchData.createdDateFrom,
                vm.searchData.createdTimeFrom
            );
            vm.preparedSearchFilter.createdDateFrom = createdDateFrom;
            var createdDateTo = vm.UtilSvc.mixteDateTime(vm.searchData.createdDateTo, vm.searchData.createdTimeTo);
            vm.preparedSearchFilter.createdDateTo = createdDateTo;

            vm.IndexFileService.search(vm.preparedSearchFilter).$promise.then(function (result) {
                vm.gridOptions.data = _.map(result, function (indexFile) {
                    return new vm.IndexFile(indexFile);
                });
            });
        }

        function clearForm() {
            // Reset data
            vm.searchData = new vm.IndexFilesFilter();
            // Recherche
            vm.search();
        }

        // Indique si l'export CSV de la grille peut être réalisé
        vm.canExportGridCsv = function () {
            if (!(vm.gridApi === undefined || vm.gridApi.selection === undefined)) {
                return vm.gridApi.selection.getSelectedRows().length > 0;
            }
            return false;
        };

        // Indique si la clôture d'une selection de fichiers d'index peut être réalisé.
        vm.canCloseIndexFiles = function () {
            if (!(vm.gridApi === undefined || vm.gridApi.selection === undefined)) {
                var selectedRows = vm.gridApi.selection.getSelectedRows();
                var toClose = _.filter(selectedRows, function (indexFile) {
                    return indexFile.status === 'ERROR';
                });
                return toClose.length > 0;
            }
            return false;
        };

        // Exporte toutes les colonnes des lignes sélectionnées dans un fichier CSV
        vm.exportGridCsv = function () {
            // Nom du fichier CSV : epdf_DateHeure_dataLots.csv
            var now = new Date();
            var filename = 'epdf_' + vm.DateService.formatAsYMD_HM(now) + '_dataReferencesInconnues.csv';
            vm.gridOptions.exporterCsvFilename = filename;

            var myElement = angular.element(document.querySelectorAll('.custom-csv-link-location'));
            vm.gridApi.exporter.csvExport('selected', 'all', myElement);
        };

        vm.closeIndexFile = function () {
            openModal();
        };

        function openModal() {
            vm.$uibModal
                .open({
                    animation: true,
                    component: 'unknown-batch-ref-modal',
                    resolve: {
                        nbSelected: function () {
                            return vm.gridApi.selection.getSelectedRows().length;
                        },
                    },
                })
                .result.then(
                    function (comments) {
                        var indexfiles = [];
                        var selectedRows = vm.gridApi.selection.getSelectedRows();
                        for (var i = 0; i < selectedRows.length; i++) {
                            indexfiles.push(selectedRows[i].id);
                        }
                        vm.IndexFileService.close(
                            { indexfiles: indexfiles, comments: comments },
                            function () {
                                vm.toastr.success(
                                    vm.$translate.instant('process.indexfile.toaster.success'),
                                    vm.$translate.instant('process.indexfile.toaster.title'),
                                    { timeOut: 7000 }
                                );
                                vm.search();
                            },
                            function (/*error*/) {
                                vm.toastr.error(vm.$translate.instant('process.indexfile.toaster.error'));
                            }
                        );
                    },
                    function () {}
                );
        }

        vm.getSelectedIndexFileIds = function () {
            var indexFileIds = '';
            if (!(vm.gridApi === undefined || vm.gridApi.selection === undefined)) {
                var selectedRows = vm.gridApi.selection.getSelectedRows();
                for (var i = 0; i < selectedRows.length; i++) {
                    indexFileIds += selectedRows[i].id + ';';
                }
            }
            return indexFileIds;
        };

        vm.getTableHeight = function () {
            return gridHeight(vm.gridApi);
        };
    }
}

angular.module('indexfile').component('unknownBatchRef', {
    templateUrl: require('./unknown-batchref.html'),
    controller: UnknownBatchRefCtrl,
});
